import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_ds_get_packagings_by_materialService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { owner_lookup?: string, project_lookup?: string, material_lookup?: string }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, BasePackagingId?: number, BasePackagingQuantity?: number, DimensionUomId?: number, Height?: number, IsBasePackaging?: boolean, IsOrderDefault?: boolean, IsReportingDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, SubPackagingId?: number, SubPackagingQuantity?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, WeightUom?: { Name?: string, Short_name?: string }, VolumeUom?: { Name?: string, Short_name?: string }, DimensionsUom?: { Name?: string, Short_name?: string }, Packaging?: { Name?: string, ShortName?: string }, BasePackaging?: { Name?: string, ShortName?: string }, Material?: { ControllerTypeId?: number, IsFixedWeight?: boolean, ControllerType?: { Name?: string } } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { owner_lookup?: string, project_lookup?: string, material_lookup?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, BasePackagingId?: number, BasePackagingQuantity?: number, DimensionUomId?: number, Height?: number, IsBasePackaging?: boolean, IsOrderDefault?: boolean, IsReportingDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, SubPackagingId?: number, SubPackagingQuantity?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, WeightUom?: { Name?: string, Short_name?: string }, VolumeUom?: { Name?: string, Short_name?: string }, DimensionsUom?: { Name?: string, Short_name?: string }, Packaging?: { Name?: string, ShortName?: string }, BasePackaging?: { Name?: string, ShortName?: string }, Material?: { ControllerTypeId?: number, IsFixedWeight?: boolean, ControllerType?: { Name?: string } } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { owner_lookup?: string, project_lookup?: string, material_lookup?: string, $keys: { MaterialId?: number, PackagingId?: number }[] }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, BasePackagingId?: number, BasePackagingQuantity?: number, DimensionUomId?: number, Height?: number, IsBasePackaging?: boolean, IsOrderDefault?: boolean, IsReportingDefault?: boolean, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, SubPackagingId?: number, SubPackagingQuantity?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, WeightUom?: { Name?: string, Short_name?: string }, VolumeUom?: { Name?: string, Short_name?: string }, DimensionsUom?: { Name?: string, Short_name?: string }, Packaging?: { Name?: string, ShortName?: string }, BasePackaging?: { Name?: string, ShortName?: string }, Material?: { ControllerTypeId?: number, IsFixedWeight?: boolean, ControllerType?: { Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      owner_lookup?: string, project_lookup?: string, material_lookup?: string    }) {
      return false;
    }
}
